// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"4b3f3866","230":"ca36d2f3","652":"021897ac","960":"ae6e4754"}[chunkId] + ".chunk.css";
};